import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/customExtensions",
        name: "customExtensions",
        component: () => import("@/components/customExtensions/_CustomExtensions.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewCustomExtensionsUI,
            breadcrumbs: {
                icon: "extensions-icon",
                paths: []
            },
            title: "navbar.customExtensions"
        }
    },
    {
        path: "/customExtensions/:customExtensionId/update",
        name: "updateCustomExtension",
        component: () => import("@/components/customExtensions/_CustomExtensionForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateCustomExtension,
            breadcrumbs: {
                icon: "extensions-icon",
                paths: [
                    ["/customExtensions", i18n.t("customExtensions.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/customExtensions/new",
        name: "createCustomExtension",
        component: () => import("@/components/customExtensions/_CustomExtensionForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateCustomExtension,
            breadcrumbs: {
                icon: "extensions-icon",
                paths: [
                    ["/customExtensions", i18n.t("customExtensions.title")]
                ]
            },
            title: "customExtensions.createTitle"
        },
        props: true
    },
    {
        path: "/extensions/:customExtensionId/render",
        name: "renderCustomExtension",
        component: () => import("@/components/customExtensions/_CustomExtensionRender.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewCustomExtensionsRenderUI,
            breadcrumbs: {
                icon: "extensions-icon",
                paths: []
            },
            noPaddingLayout: true
        },
        props: true
    }
];
